import { useAuth } from '@/contexts/auth-context';
import { canAccessBackofficePath } from '@/lib/role-access';
import { Navigate, useLocation } from 'react-router-dom';

export function RoleRoute({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const { pathname } = useLocation();

  if (!canAccessBackofficePath(user?.roles ?? [], pathname)) {
    return <Navigate to="/verboden" replace />;
  }
  return <>{children}</>;
}

export function ForbiddenPage() {
  return (
    <section className="mx-auto max-w-lg py-24 text-center">
      <h1 className="text-2xl font-semibold">Geen toegang</h1>
      <p className="mt-3 text-muted-foreground">Je account heeft geen toegang tot dit onderdeel.</p>
    </section>
  );
}
